import React from 'react';

import styles from './Tabulation.module.scss';

interface ITabluationProps {
  count: number;
}

export const Tabulation = ({ count }: ITabluationProps) => {
  const tabs = [];
  for (let i = 0; i < count; i += 1) {
    tabs.push(<span key={`tab${i}`} className={styles.tab} />);
  }
  return <>{tabs}</>;
};
